import {
  createFileRoute,
} from '@tanstack/react-router';

import AcceptInvite from '#features/auth/invite/AcceptInvite';

export const Route = createFileRoute('/_app/invite/accepted')({
  component: AcceptInvite,
});
